export default "__VITE_ASSET__CXgwQfal__"